export default __webpack_public_path__ + "static/media/ChristineJones-9.fef671e4.jpg";